import { render, staticRenderFns } from "./IndexTable.vue?vue&type=template&id=2d7c31f9&scoped=true"
import script from "./IndexTable.vue?vue&type=script&lang=js"
export * from "./IndexTable.vue?vue&type=script&lang=js"
import style0 from "./IndexTable.vue?vue&type=style&index=0&id=2d7c31f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7c31f9",
  null
  
)

export default component.exports